export default {
  // 用户管理
  //  用户列表
  member_list_detail: "MemberDetail",
  //  黑名单列表
  black_list_add: "BlackAdd",
  black_list_edit: "BlackEdit",
  black_list_import: "black_list_import",
  black_list_remove: "black_list_remove",

  // 权限管理
  //  管理员
  user_list_add: "UserAdd",
  user_list_edit: "UserEdit",
  user_list_del: "user_list_del",
  user_list_status: "user_list_status",
  //  角色
  role_list_add: "RoleAdd",
  role_list_edit: "RoleEdit",
  role_list_del: "role_list_del",
  role_list_menu: "role_list_menu",
  //  菜单
  menu_list_add: "MenuAdd",
  menu_list_edit: "MenuEdit",
  menu_list_del: "menu_list_del",
}
